/** @jsxImportSource @gasman/smush */

import './ornament_editor.css';

import { Model, fields } from '@gasman/smush';
import { ContainerComponent } from '@gasman/smush';

import { Counter } from '../widgets/counter';
import { NumberRow } from '../widgets/number_row';

class OrnamentEditorState extends Model([
    new fields.IntegerField('ornamentNumber', {
        label: 'Ornament',
        min: 1,
        max: 15,
        default: 1,
    }),
]) {}

class OrnamentEditor extends ContainerComponent {
    constructor(app, model) {
        super();

        this.app = app;
        this.state = null;

        this.ornamentSelector = Counter.forField(
            OrnamentEditorState.fields.ornamentNumber,
        );

        this.auditionButton = <button>Test</button>;
        this.auditionButton.addEventListener('mousedown', (event) => {
            // only trigger on left mouse button
            if (event.button != 0) return;

            if (this.state) {
                this.app.player.auditionOrnament(this.state.ornamentNumber);
            }
        });
        this.auditionButton.addEventListener('mouseup', (event) => {
            // only trigger on left mouse button
            if (event.button != 0) return;

            this.app.player.stop();
        });

        this.toneRow = NumberRow.forField(model.fields.tones);

        this.ornamentPropertyEditors = [this.toneRow];
        this.components = [this.ornamentSelector, this.toneRow];
    }

    render(container) {
        container.appendChild(
            <div class="ornament-editor">
                {this.ornamentSelector}
                {this.auditionButton}
                {this.toneRow}
            </div>,
        );
    }

    unbindOrnament() {
        this.ornamentPropertyEditors.forEach((component) => {
            component.unbind();
        });
    }

    bind(song, opts) {
        opts = opts || {};

        this.unbindOrnament();
        this.song = song;
        this.state = new OrnamentEditorState();
        this.undoBuffer = opts.undoBuffer;
        this.undoPath = opts.undoPath;

        this.selectOrnament(this.state.ornamentNumber);
        this.state.on('changeOrnamentNumber', this.selectOrnament);
        this.ornamentSelector.bind(this.state);
    }
    unbind() {
        this.unbindOrnament();
        this.song = null;
        this.state.removeListener('changeOrnamentNumber', this.selectOrnament);
        this.state = null;
        this.undoBuffer = null;
        this.undoPath = null;
    }

    selectOrnament = (ornamentNumber) => {
        let ornament = this.song.getOrnament(ornamentNumber);

        let opts = {};
        if (this.undoBuffer) {
            opts.undoBuffer = this.undoBuffer;
            opts.undoPath = [...this.undoPath, ornamentNumber];
        }

        this.ornamentPropertyEditors.forEach((component) => {
            component.bind(ornament, opts);
        });
    };
}

export { OrnamentEditor };
